export const LANGUAGE_STORAGE_KEY = 'playbook.language';
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'es', 'ht', 'pt', 'zh'];

export function isSupportedLanguage(language) {
  return SUPPORTED_LANGUAGES.includes(language);
}

export function getUrlLanguage() {
  if (typeof window === 'undefined') {
    return null;
  }

  const urlLanguage = new URLSearchParams(window.location.search).get('lang');
  return isSupportedLanguage(urlLanguage) ? urlLanguage : null;
}

export function getStoredLanguage() {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const urlLanguage = getUrlLanguage();
  if (urlLanguage) {
    return urlLanguage;
  }

  const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return isSupportedLanguage(storedLanguage) ? storedLanguage : DEFAULT_LANGUAGE;
}

export function persistLanguage(language) {
  if (typeof window === 'undefined' || !isSupportedLanguage(language)) {
    return;
  }

  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}
